enum CompanyTypeConstants {
  UNDEFINED = 'UNDEFINED',
  INTERNAL_COMPANY = 'INTERNAL_COMPANY',
  COMMERCIAL_COMPANY = 'COMMERCIAL_COMPANY',
  PROMOTIONAL_COMPANY = 'PROMOTIONAL_COMPANY',
}

export default CompanyTypeConstants;
